



























































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import  dialogPanel  from "./dialogPanel.vue"
import  NumberKeyboard  from "./NumberKeyboard.vue"
import  selectAddressPanel  from "./selectAddressPanel.vue"
import { TbGoodsClass, TbSupplier } from "@/http";
 @Component({
    components: {dialogPanel,NumberKeyboard,selectAddressPanel},
}) 
export default class addSupplierPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    isEdit:Boolean;

   
    show=false;
   

    
    title="新增分类";

    isloading=false;
    isloading2=false;

    form={
        name:"",
        contactsName:"",
        phone:"",
        province:"", 
        city:"", 
        area:"", 
        address:"", 
        remarks:"", 
        isForbidden:false,
    }
    addressName="";

    userInfo:any={};


    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }
    async created() {
    
    }

    showAddress(){
        this.$refs['selectAddressPanel'].showFun();
    }

   
    showFun(form){
        this.title = this.isEdit?"编辑供应商":"新增供应商";
        this.show = true;
        if(form){
            this.form = form;
            this.addressName = form.province+form.city+form.area;
        }
    }

    finishNum(val){
        this.form.phone = val;
    }

    async saveFun(val){
        if(!this.form.name) return;
        if(!this.form.name){
            Toast("请输入供应商名称");
            return;
        }
        if(this.isloading) return;
        this.isloading = true;

        if(!this.isEdit){
            try {
                let form = Object.assign({},
                    this.form,{
                        creatorId:this.userInfo.id,
                        creatorName:this.userInfo.name
                    }
                )
                let res = await  TbSupplier.PostTbSupplier(form)
                this.isloading = false;
                Toast("新增成功")
                let sInfo ={
                    name:this.form.name,
                    id:res.id
                }
                this.$emit("confirmSave",sInfo);
                this.closeFun();
            } catch (error) {
                this.isloading = false;
            }
        }else{
            try {
                let res = await  TbSupplier.PutTbSupplier(this.form)
                this.isloading = false;
                Toast("编辑成功")
                this.$emit("confirmSave");
                this.closeFun();
            } catch (error) {
                this.isloading = false;
            }

        }
        
    }
    resetForm(){
       this.form={
            name:"",
            contactsName:"",
            phone:"",
            province:"", 
            city:"", 
            area:"", 
            address:"", 
            remarks:"", 
            isForbidden:false,
       } 
       this.addressName = "";
    }
   
    closeFun(){
        this.resetForm();
        this.show = false;
    }
    onConfirmAddress(value){
        let arr= JSON.parse(value);
        this.form.province = arr[0];
        this.form.city = arr[1];
        this.form.area = arr[2];
        this.addressName = this.form.province+this.form.city+this.form.area;
    }
    changeStatus(val){
        this.form.isForbidden=val;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/addSupplierPanel.vue